'use client';

import { SimpleGrid } from '@chakra-ui/react';
import { HomeCard } from '../cards/HomeCard';
import { NestedHome, NestedUser } from '@habity/types';
import { NoResults } from './components/NoResults';
import { placeholderHomes } from '@habity/constants';
import { getHomePath } from '@habity/services';
import { useGridFullRows } from '~/hooks/useGridFullRows';

type HomesGridProps = {
  // TODO: Replace with HomeCardData[]
  homes?: NestedHome[] | null;
  homesLoading: boolean;
  user?: NestedUser;
  isLoggedIn?: boolean;
  hasMore: boolean;
  isLoadingMore?: boolean;
};

export const HomesGrid = ({
  homes: realHomes,
  homesLoading,
  user,
  isLoggedIn = false,
  hasMore,
}: HomesGridProps) => {
  // Add placeholders for the initial loading state if tab is activated
  // Placeholders for new page loading are handled within the useObserver hook
  const homes =
    homesLoading && realHomes && realHomes.length === 0
      ? placeholderHomes
      : realHomes && realHomes.length > 0
        ? realHomes
        : [];

  const { gridRef, visibleItems: visibleHomes } = useGridFullRows(
    homes,
    hasMore
  );
  const actualVisibleHomes =
    homes.length === 0 && !homesLoading ? [] : visibleHomes;

  if (!actualVisibleHomes || !actualVisibleHomes.length) {
    return <NoResults tab="homes" />;
  }

  return (
    <SimpleGrid
      ref={gridRef}
      columns={{ mobile: 1, tablet: 2, desktop: 3 }}
      rowGap="10"
      columnGap="5"
      pb={{ mobile: '12', desktop: '24' }}
      pt="0"
    >
      {actualVisibleHomes.map((home: NestedHome) => (
        <HomeCard
          key={home.id}
          home={home}
          user={user}
          isLoggedIn={isLoggedIn}
          href={getHomePath(home)}
          actions={false}
          onClick={() => null}
          isLoading={home?.loading || false}
        />
      ))}
    </SimpleGrid>
  );
};
